import React from 'react';
import './doorStyleBox.scss';

// پنلِ تنظیمِ «بازشو» (ورودیِ بدونِ در بینِ دو فضا) — عرض، ارتفاع و نوعِ چارچوب. همان ظاهرِ پنلِ در
const FRAMES = [
  { value: 'white', label: 'قابِ سفید' },
  { value: 'wood', label: 'قابِ چوبی' },
  { value: 'plaster', label: 'گچی (بدونِ قاب)' },
];
const WIDTH_MIN_CM = 60;
const WIDTH_MAX_CM = 400;
const HEIGHT_MIN_CM = 180;
const fa = (n) => Number(n).toLocaleString('fa-IR');

function OpeningStyleBox({ style, defaultWidthCm, defaultHeightCm, wallHeightCm, maxWidthCm, onChange, onClose }) {
  const s = style || {};
  const width = s.widthCm || defaultWidthCm || 150;
  const height = s.heightCm || defaultHeightCm || 240;
  const frame = s.frame || 'white';
  const wMax = Math.max(WIDTH_MIN_CM, Math.min(WIDTH_MAX_CM, Math.floor(maxWidthCm || WIDTH_MAX_CM)));
  const hMax = Math.max(HEIGHT_MIN_CM, (wallHeightCm || 280) - 5);
  return (
    <div className="door-style-box" onPointerDown={(e) => e.stopPropagation()}>
      <div className="door-style-box__header">
        <span>تنظیماتِ این بازشو</span>
        <button type="button" onClick={onClose}>
          بستن
        </button>
      </div>
      <div className="door-style-box__panel">
        <div className="door-style-box__field">
          <span className="door-style-box__label">عرضِ بازشو: {fa(width)} سانتی‌متر</span>
          <input
            type="range"
            min={WIDTH_MIN_CM}
            max={wMax}
            step={5}
            value={Math.min(width, wMax)}
            onChange={(e) => onChange({ widthCm: Number(e.target.value) })}
            className="door-style-box__slider"
          />
        </div>
        <div className="door-style-box__field">
          <span className="door-style-box__label">ارتفاعِ بازشو: {fa(height)} سانتی‌متر</span>
          <input
            type="range"
            min={HEIGHT_MIN_CM}
            max={hMax}
            step={5}
            value={Math.min(height, hMax)}
            onChange={(e) => onChange({ heightCm: Number(e.target.value) })}
            className="door-style-box__slider"
          />
        </div>
        <div className="door-style-box__field">
          <span className="door-style-box__label">چارچوب</span>
          <div className="door-style-box__pills">
            {FRAMES.map((f) => (
              <button key={f.value} type="button" className={frame === f.value ? 'is-active' : ''} onClick={() => onChange({ frame: f.value })}>
                {f.label}
              </button>
            ))}
          </div>
        </div>
        <p className="door-style-box__hint">بالای بازشو نعل‌درگاه (دیوار) است و دورِ آن چارچوب؛ ارتفاع را تا زیرِ سقف می‌شود بالا برد.</p>
      </div>
    </div>
  );
}

export default OpeningStyleBox;
